<template>
    <div data-cy="list_profile_address_delivery">
        <AddressListItem
                v-for="(address, k) in addressList"
                :address="address"
                :key="k"
                @onDeleteAddress="onDeleteAddress($event)"
                @onEditAddress="onEditAddress($event)"
        ></AddressListItem>

        <div v-if="isLoaded && addressList.length == 0" data-cy="container_profile_address_delivery_empty">
            <div class="text-lg font-bold text-gray-300 text-center py-5" data-cy="text_profile_address_delivery_empty">
                No Address
            </div>
        </div>
    </div>
</template>
<script>
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from '@/mixin/ModalMixin';
import AddressListItem from "./AddressListItem.vue";
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

/**
 * @event onDeleteAddress
 * @event onEditAddress
 */
export default {
    name: "AddressList",
    mixins: [ErrorApiMixin, ModalMixin],
    components: {
        AddressListItem,
    },
    data: function() {
        return {
            addressList: [],
            isLoaded: false,
        };
    },
    mounted: function() {
        this.getAddressList();
    },
    methods: {
        getAddressList: function() {
            BzbsAddressList.apiGetAddressList().subscribe((addressList) => {
                this.addressList = addressList;
                this.isLoaded = true;
            }, (err) => {
                this.isLoaded = true;
                this.errorApi(err);
            });
        },

        onDeleteAddress: function(address) {
            this.$emit('onDeleteAddress', address);
        },
        onEditAddress: function(address) {
            this.$emit('onEditAddress', address);
        },
    },
}
</script>
